import angular from 'angular';

import utils from 'utils/lsp-utils-service';
import RetailerFilterDirective from './retailer-filter-directive';

export default angular.module('retailer-filter', []).directive('retailerFilter', utils.createNgFactory(RetailerFilterDirective));



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/retailer-filter/retailer-filter-module.js